import Classes from "./CountForm.module.css"

export const OtherProductsCountForm = () => {


  return <div className={Classes.main_div}>This is the other producst count form</div>
}
